import React from 'react'
import type { SVGProps } from 'react'

export default function AzFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24px'
      height='24px'
      viewBox='0 0 512 512'
      {...props}
    >
      <mask id='circleFlagsAz'>
        <circle cx={256} cy={256} r={256} fill='#fff' />
      </mask>
      <g mask='url(#circleFlagsAz)'>
        <path fill='#338af3' d='M0 0h512v170.7H0z' />
        <path fill='#ef233c' d='M0 170.7h512v170.6H0z' />
        <path fill='#6da544' d='M0 341.3h512V512H0z' />
        <circle cx={244.9} cy={256} r={66.1} fill='#eee' />
        <circle cx={261.8} cy={256} r={66.1} fill='#ef233c' />
        <path
          fill='#eee'
          d='m289.5 208.3 10.6 32.8 34.5-1.2-28.7 19.1 11.8 32.4-27.5-20.8-27.5 20.8 11.8-32.4-28.7-19.1 34.5 1.2z'
        />
      </g>
    </svg>
  )
}
